export default __webpack_public_path__ + "static/cta-center-image-b42c5f648264fa03df4acaaea54a5fe1.png";